import React from "react";
import styled from "styled-components";

export const OpenButtonSvg = () => {
    return <OpenButtonSvgContent viewBox="0 0 256 256">
        <path d="M118,128L12.3,231.2c-3,2.9-3.1,7.8-0.1,10.8c2.9,3,7.8,3.1,10.8,0.1l111-108.4c1.6-1.6,2.4-3.6,2.3-5.7c0.1-2.1-0.7-4.1-2.3-5.7L23,13.8c-3-2.9-7.8-2.9-10.8,0.1c-2.9,3-2.9,7.8,0.1,10.8L118,128L118,128z"/><path fill="#000000" d="M138,128L243.7,24.8c3-2.9,3.1-7.8,0.1-10.8c-2.9-3-7.8-3.1-10.8-0.1L122,122.3c-1.6,1.6-2.4,3.6-2.3,5.7c-0.1,2.1,0.7,4.1,2.3,5.7l111,108.4c3,2.9,7.9,2.9,10.8-0.1c2.9-3,2.9-7.8-0.1-10.8L138,128L138,128z" />
    </OpenButtonSvgContent>
}

const OpenButtonSvgContent = styled.svg`
    width: 18px;
    height: 18px;
    transform: rotate(45deg);
`;
